import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import { useSettings } from "@/hooks/queries";
import { waLink } from "@/lib/format";

const Contact = ({ icon: Icon, children, href, testId }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testId} className="flex items-center gap-3 text-sm text-neutral-400 transition-colors hover:text-gold">
    <Icon className="h-4 w-4 shrink-0" />
    {children}
  </a>
);

export const Footer = () => {
  const { data: s } = useSettings();
  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-3xl italic">{s?.business_name}</p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-neutral-500">{s?.tagline}</p>
        </div>
        <div className="space-y-4 md:col-span-4">
          <p className="overline-label">Kontak</p>
          {s?.whatsapp && <Contact icon={MessageCircle} href={waLink(s.whatsapp, "Halo, saya ingin bertanya tentang private trip.")} testId="footer-whatsapp">{s.whatsapp}</Contact>}
          {s?.instagram && <Contact icon={Instagram} href={`https://instagram.com/${s.instagram.replace("@", "")}`} testId="footer-instagram">{s.instagram}</Contact>}
          {s?.email && <Contact icon={Mail} href={`mailto:${s.email}`} testId="footer-email">{s.email}</Contact>}
          {s?.address && (
            <p className="flex items-center gap-3 text-sm text-neutral-400"><MapPin className="h-4 w-4 shrink-0" />{s.address}</p>
          )}
        </div>
        <div className="space-y-3 md:col-span-3">
          <p className="overline-label">Menu</p>
          <Link to="/#trip" className="block text-sm text-neutral-400 hover:text-white" data-testid="footer-link-trip">Daftar Trip</Link>
          <Link to="/jadwal" className="block text-sm text-neutral-400 hover:text-white" data-testid="footer-link-jadwal">Jadwal</Link>
          <Link to="/cek-pesanan" className="block text-sm text-neutral-400 hover:text-white" data-testid="footer-link-cek">Cek Pesanan</Link>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-6 text-xs text-neutral-600 sm:px-8">
          <span>© {new Date().getFullYear()} {s?.business_name}</span>
          <Link to="/admin/login" className="hover:text-neutral-400" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
